import { FC } from "react";
import { FeedbackStatus } from "../../interfaces/endpoints/ICustomerFeedback";
import {
  STATUS_BADGE_CLASSES,
  STATUS_LABELS
} from "../../utils/customerFeedback/labels";

interface StatusBadgeProps {
  status: FeedbackStatus;
}

// Triage-state pill (New / Reviewed / Actioned). Kept visually
// quieter than the source badge — it's the column the BD team scans
// fastest, so colour-coding has to be readable at a glance without
// being a distraction.
const StatusBadge: FC<StatusBadgeProps> = ({ status }) => {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium
        ${STATUS_BADGE_CLASSES[status]}`}
    >
      {STATUS_LABELS[status]}
    </span>
  );
};

export default StatusBadge;
